import React from "react";
import { DefenseStats } from "../../../../types/LogTypes";
import { useRoster } from "../../../../contexts/RosterContext";
import {
  Box,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import { jerseyNumberNameDisplay } from "../../../../helpers/helpers";

interface Props {
  defenseStats?: DefenseStats;
}

export const Defense: React.FC<Props> = ({ defenseStats }) => {
  const { rosterPlayers } = useRoster();
  if (!defenseStats) {
    return null;
  }

  // sort defense stats by total tackles
  const sortedDefenseStats = Object.entries(defenseStats).sort(
    (a, b) =>
      b[1].solo_tackles +
      b[1].assisted_tackles -
      (a[1].solo_tackles + a[1].assisted_tackles)
  );

  return (
    <Box>
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          mb: 2,
          gap: 2,
        }}
      >
        <Typography variant="h6">Defense</Typography>
      </Box>
      <TableContainer>
        <Table className="stats-table">
          <TableHead>
            <TableRow>
              <TableCell className="player-name">Player</TableCell>
              <TableCell className="stat-cell">Total Tackles</TableCell>
              <TableCell className="stat-cell">Solo Tackles</TableCell>
              <TableCell className="stat-cell">Assisted Tackles</TableCell>
              <TableCell className="stat-cell">Tackles for Loss</TableCell>
              <TableCell className="stat-cell">Fumbles Recovered</TableCell>
              <TableCell className="stat-cell">Interceptions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedDefenseStats.map(([rosterId, stats]) => {
              const player = rosterPlayers.find(
                (p) => p.id === parseInt(rosterId)
              );
              return (
                <TableRow key={rosterId}>
                  <TableCell className="player-name">
                    {jerseyNumberNameDisplay(player)}
                  </TableCell>
                  <TableCell className="stat-cell">
                    {stats.solo_tackles + stats.assisted_tackles}
                  </TableCell>
                  <TableCell className="stat-cell">
                    {stats.solo_tackles}
                  </TableCell>
                  <TableCell className="stat-cell">
                    {stats.assisted_tackles}
                  </TableCell>
                  <TableCell className="stat-cell">
                    {stats.tackles_for_loss}
                  </TableCell>
                  <TableCell className="stat-cell">
                    {stats.fumbles_recovered}
                  </TableCell>
                  <TableCell className="stat-cell">
                    {stats.interceptions}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};
